import { render, staticRenderFns } from "./DetailNo.vue?vue&type=template&id=b78c0160&scoped=true"
import script from "./DetailNo.vue?vue&type=script&lang=js"
export * from "./DetailNo.vue?vue&type=script&lang=js"
import style0 from "./DetailNo.vue?vue&type=style&index=0&id=b78c0160&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78c0160",
  null
  
)

export default component.exports